/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC } from 'react';
import * as S from './styled';
import { ChartImage } from './components';
import { BrandButton } from '../../../everydoggyV2/brandButton/brandButton';
import {
  analyticsEventsTracker,
  GTMOnboardingFunnelEvent,
  EVENT_TRACKERS,
} from '../../../../utils/analytics';
import locales from '../../../../content.json';
import { getParameterFromURL } from '../../../../utils/scripts';
import closeImage from './img/close.png';
import closeImageDark from './img/closeDark.png';
import discount from './img/discount.png';
import discount2 from './img/discount2.png';
import discount3 from './img/discount3.png';

interface Props {
	closeHandler?: () => void;
	showModalDiscount: boolean;
}

export const PaymentModalDiscount: FC<Props> = props => {
	const { closeHandler, showModalDiscount } = props;
	const darkTheme = getParameterFromURL('darkTheme') === 'true';
	const v49p24 =
		getParameterFromURL('config') === 'customV49' &&
		getParameterFromURL('tariff') === 'v43';
	const v49p27 =
		getParameterFromURL('config') === 'customV49' &&
		getParameterFromURL('tariff') === 'v45';
	const v51p27 =
		getParameterFromURL('config') === 'customV51' &&
		getParameterFromURL('tariff') === 'v45';

	const discountOfferImage = v49p24 || v49p27 || v51p27 ? discount3 : discount;

const buttonTextKey =
  v49p24 || v49p27 || v51p27
    ? locales[window.userLang].payment_text_225
    : locales[window.userLang].payment_text_64;

	let offerTextHtml = locales[window.userLang]?.payment_text_63;

	if (v49p24 || v49p27 || v51p27) {
		offerTextHtml = offerTextHtml.replace(/\b65\b/g, '70');
	}

	function addEventsСhooseSpecialOffer () {
    analyticsEventsTracker.trackWithTarget(
      GTMOnboardingFunnelEvent.chooseSpecialOffer(),
      EVENT_TRACKERS.GTM
    );
  };

	const p13MixPaywallDiscountPercent = getParameterFromURL('p13MixPaywallDiscountPercent');

	return (
		<S.PaymentModalDiscount showModalDiscount={showModalDiscount}>
			<S.CloseButtonContainer>
				<S.CloseButton onClick={closeHandler} >
					<img src={darkTheme ? closeImageDark : closeImage} />
				</S.CloseButton>
			</S.CloseButtonContainer>
			<S.Margined>
				<S.Title>{locales[window.userLang].payment_text_57}</S.Title>
				<S.Wrapper>
					<S.ChartWrapper>
						<S.ChartContainer>
							<ChartImage />
							<S.Bubble2>{locales[window.userLang].payment_text_58}</S.Bubble2>
							<S.Bubble3>{locales[window.userLang].payment_text_59}</S.Bubble3>
						</S.ChartContainer>
					</S.ChartWrapper>
					<S.Description>
						<p>{locales[window.userLang].payment_text_60}</p>
						<p>{locales[window.userLang].payment_text_61}</p>
					</S.Description>
				</S.Wrapper>
			</S.Margined>
			<S.Offer>

				{p13MixPaywallDiscountPercent ? (
					<S.OfferImg src={discount2} />
				) : (
					<S.OfferImg src={discountOfferImage} />
				)}

				<h4>{locales[window.userLang].payment_text_62}</h4>

				{p13MixPaywallDiscountPercent ? (
					<S.OfferText dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_209}} />
				) : (
					<S.OfferText dangerouslySetInnerHTML={{ __html: offerTextHtml }} />
				)}

				<S.ButtonWrapper>
					<BrandButton
						noShadows={true}
						onClick={() => {
							addEventsСhooseSpecialOffer();
							closeHandler();
						}}
					>

						{p13MixPaywallDiscountPercent ? (
							<p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_208}} />
						) : (
							<p dangerouslySetInnerHTML={{ __html: buttonTextKey }} />
						)}

					</BrandButton>
				</S.ButtonWrapper>
			</S.Offer>
		</S.PaymentModalDiscount>
	);
};
